import {runOnPage} from './general.js';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

runOnPage('how-we-work-default', () => {
	$(function () {
		const rightScroll = document.getElementById('right-scroll');

		window.addEventListener('wheel', function (e) {
			if (!rightScroll || rightScroll.offsetParent === null) {
				return;
			}

			const rect = rightScroll.getBoundingClientRect();
			const inColumn =
				e.clientX >= rect.left &&
				e.clientX <= rect.right &&
				e.clientY >= rect.top &&
				e.clientY <= rect.bottom;

			if (inColumn) {
				return;
			}

			const scrollTop = rightScroll.scrollTop;
			const scrollHeight = rightScroll.scrollHeight;
			const clientHeight = rightScroll.clientHeight;
			const deltaY = e.deltaY;

			const canScrollDown = deltaY > 0 && scrollTop + clientHeight < scrollHeight;
			const canScrollUp = deltaY < 0 && scrollTop > 0;

			if (canScrollDown || canScrollUp) {
				rightScroll.scrollTop += deltaY;
				e.preventDefault();
			}
		}, {passive: false});

		const cards = gsap.utils.toArray('.stacked-card');
		const offset = 15;
		const offScreen = window.innerHeight * 0.8;
		const cardSpacing = window.innerHeight * 0.2;

		function setInitialPositions() {
			cards.forEach((card, i) => {
				gsap.set(card, {
					y: offScreen + cardSpacing * i,
					scale: 1.8,
					opacity: 1
				});
			});
		}
		setInitialPositions();

		gsap.to(cards[0], {
			y: 0,
			scale: 1,
			ease: "power2.out",
			scrollTrigger: {
				trigger: ".stacked-cards-section",
				start: "top bottom",
				end: "top top",
				scrub: true
			}
		});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: ".stacked-cards-section",
				start: "top top",
				end: `+=${(cards.length - 1) * 60}%`,
				scrub: true,
				pin: ".stacked-cards-wrapper",
				anticipatePin: 1
			}
		});

		tl.to(cards.slice(1), {
			scale: 1,
			duration: 0.3,
			stagger: 0.3,
			ease: "power2.out"
		}, 0);

		tl.to(cards.slice(1), {
			y: i => offset * (i+1),
			duration: 0.6,
			stagger: 0.3,
			ease: "power2.out"
		}, 0);

		ScrollTrigger.addEventListener("refreshInit", setInitialPositions);
		ScrollTrigger.refresh();
	});

	// SCROLL TO SECTION
	$(window).on('load', function () {
		if (window.location.hash === '#what-we-do') {
			const $el = $('#what-we-do');
			if ($el.length) {
				setTimeout(function () {
					$el[0].scrollIntoView({ behavior: 'smooth' });
				}, 50);
			}
		}
	});
});
